import { Components, Theme } from "@mui/material";

export const MuiIconButton: Components<Theme>["MuiIconButton"] = {
  styleOverrides: {
    root: {
      padding: ".5rem",
      borderRadius: ".75rem",
      border: "1px solid #C2CEF4",
      boxShadow: "0 -1px 0 0 #ECEEFA inset;",
    },
  },
  variants: [
    {
      props: {
        color: "primary",
      },
      style: ({ theme }) => ({
        background: theme.palette.primary.main,
      }),
    },
  ],
};
